{
    "DatePattern": "GG-MM-AAAA",
    "NAME": "Date"
}